const Routes = [
  {
    path: '/stock-break',
    name: 'stockBreak',
    component: () => import('@/app/stock_break/TheStockBreak'),
    redirect: '/stock-break/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        component: () => import('@/app/stock_break/views/Index'),
        name: 'stockBreakIndex'
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/stock_break/Routes.js